// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"80":"af08d8e0","227":"902abb7a","512":"9b3c2613","918":"6a445978","962":"cc1a59a9","997":"2ba5ae47"}[chunkId] + ".js";
};